import * as apis from './api'
import storageUtil from '@/utils/storageUtil'
import { LANGUAGE } from '@/constants'
import { snakeCase } from 'lodash'
import { getLocalLang } from '@/utils'

// retry define
const RETRY_TIMES = 3
let current_retry_time = 0
const appid = process.env.INTERCOME_APPID

// object convert to snakeCase
const object2snakeCase = (o: Record<string, any>) => {
  return Object.keys(o).reduce((acc, key) => {
    acc[snakeCase(key)] = o[key]
    return acc
  }, {} as Record<string, any>)
}

export const getIntercomConfig = () => {
  const interComConfig = storageUtil.get('interComConfig') ?? {}
  const selfLanguageInfo = LANGUAGE.filter((item) => item.lang === getLocalLang()?.[0]?.lang)
  const localLang = selfLanguageInfo[0] ? selfLanguageInfo[0].languageType : 'en'
  return Object.assign(
    { default_language_code: localLang, alignment: 'right', horizontal_padding: 20, vertical_padding: 60 },
    object2snakeCase(interComConfig)
  ) as IIntercomSettings
}
async function getUserConf() {
  const { data: intercomConfig } = await apis.getIntercomConfig()
  storageUtil.set('interComConfig', intercomConfig)
  return intercomConfig
}
/**
 * 已经登录情况下的初始化
 */
export function insertIntercomWithLogin() {
  getUserConf().then(() => {
    insertIntercom()
  })
}
export function insertIntercom(): Promise<any> {
  return new Promise((resolve, reject) => {
    const w = window
    const ic = w.Intercom
    const interComConfig = { app_id: appid, ...getIntercomConfig() }

    if (typeof ic === 'function') {
      ic('reattach_activator')
      ic('update', w.intercomSettings || interComConfig)
      resolve(ic)
    } else {
      window.intercomSettings = interComConfig
      const script = document.createElement('script')
      script.async = true
      script.src = `https://widget.intercom.io/widget/${appid}`

      script.onload = () => {
        resolve(w.Intercom)
      }

      /**
       * error retry
       */
      script.onerror = () => {
        if (current_retry_time >= RETRY_TIMES) {
          reject()
        } else {
          current_retry_time++
          insertIntercom()
        }
      }
      const x = document.getElementsByTagName('script')[0]
      x.parentNode?.insertBefore(script, x)
    }
  })
}

export function updateIntercom(data?: Record<string, any>) {
  const w = window
  return insertIntercom().then((ic) => {
    w.intercomSettings = {
      ...getIntercomConfig(),
      ...(data ?? {}),
    }
    ic('update', { ...w.intercomSettings })
  })
}

export function updateIntercomLanguage() {
  updateIntercom()
}

export async function updateIntercomUserInfo() {
  const { data: intercomConfig } = await apis.getIntercomConfig()
  storageUtil.set('interComConfig', intercomConfig)
  updateIntercom(intercomConfig)
}

export function shutdownIntercom() {
  const w = window
  const ic = w.Intercom
  ic?.('shutdown')
  storageUtil.remove('interComConfig')
  window.Intercom = undefined
  window.intercomSettings = undefined
}

export function showIntercom() {
  const w = window
  const ic = w.Intercom
  ic?.('show')
}
